import moment from 'moment';
import React from 'react';
import { Badge } from 'reactstrap';

// Formatadores partilhados entre a tabela (ConnectivityIncidents) e o modal de
// detalhe (ConnectivityIncidentDetailModal). Os que precisam de traducao recebem o intl.

export const formatUtcDate = (value) => {
    if (!value) return '';
    return moment.utc(value).local().format('YYYY-MM-DD HH:mm:ss');
}

export const incidentTypeIcon = (value) => {
    switch (value) {
        case 'ChannelError': return 'fas fa-exclamation-triangle';
        case 'ChannelSendDelay': return 'fas fa-hourglass-half';
        case 'ReservationPmsDelay': return 'fas fa-inbox';
        default: return 'fas fa-question-circle';
    }
}

export const formatIncidentType = (intl, value) => {
    switch (value) {
        case 'ChannelError': return intl.formatMessage({ id: "connectivity.type.channelError" });
        case 'ChannelSendDelay': return intl.formatMessage({ id: "connectivity.type.channelSendDelay" });
        case 'ReservationPmsDelay': return intl.formatMessage({ id: "connectivity.type.reservationPmsDelay" });
        default: return value;
    }
}

export const formatState = (intl, value) => {
    switch (value) {
        case 'Open': return intl.formatMessage({ id: "connectivity.state.open" });
        case 'Resolved': return intl.formatMessage({ id: "connectivity.state.resolved" });
        default: return value;
    }
}

// Duração do incidente:
// - Open: agora - StartedAt (quanto tempo está aberto)
// - Resolved: ResolvedAt - StartedAt (quanto tempo durou)
export const formatDuration = (row) => {
    if (!row || !row.startedAt) return '';
    const start = moment.utc(row.startedAt);
    const end = row.resolvedAt ? moment.utc(row.resolvedAt) : moment.utc();
    const ms = end.diff(start);
    if (ms < 0) return '';
    const dur = moment.duration(ms);
    const days = Math.floor(dur.asDays());
    const hours = dur.hours();
    const minutes = dur.minutes();
    // Escolher granularidade legível: >= 1 dia → "3d 4h"; >= 1h → "4h 20m"; < 1h → "20m"
    if (days >= 1) return `${days}d ${hours}h`;
    if (hours >= 1) return `${hours}h ${minutes}m`;
    return `${Math.max(minutes, 1)}m`;
}

export const renderSeverityBadge = (intl, value) => {
    const color = value === 'Critical' ? 'danger' : 'warning';
    const label = value === 'Critical'
        ? intl.formatMessage({ id: "connectivity.severity.critical" })
        : intl.formatMessage({ id: "connectivity.severity.warning" });
    return <Badge color={color}>{label}</Badge>;
}

export const renderStateBadge = (intl, value) => {
    const color = value === 'Resolved' ? 'success' : 'warning';
    return <Badge color={color}>{formatState(intl, value)}</Badge>;
}
